import { buckets } from "./internalModules";
import { Dist } from "./Dist";
import Graphics, { updateCameraToScene } from "./Graphics";
import {WallType} from "./internalModules";
import {WallTypeRibbon} from "./internalModules";


export class WallTypeWindow extends WallTypeRibbon {

  glazedWidth: Dist //the width of window

  constructor (height: Dist, width: Dist, windowToWallRatio: number) {
    super(height, width, windowToWallRatio)
    this.className = 'WallTypeWindow'
    this.glazedHeight = new Dist(Math.sqrt(windowToWallRatio) * height.ft, 0)
    this.glazedWidth = new Dist(Math.sqrt(windowToWallRatio) * width.ft, 0)
    this.wallTypeGlazed = new WallType(this.glazedHeight, this.glazedWidth)
    this.wallTypeSolid = new WallType(this.height, this.width)
  }

  //method to update module height
  updateHeight(ht: Dist) {
    this.height = ht
    this.glazedHeight = new Dist(Math.sqrt(this.wwr) * ht.ft, 0)
    this.regenSubtypes()
    this.calculateGwpSF()
    this.regenGeometry()
  }

  //method to update module width
  updateWidth(wd: Dist) {
    this.width = wd
    this.glazedWidth = new Dist(Math.sqrt(this.wwr) * wd.ft, 0)
    this.regenSubtypes()
    this.calculateGwpSF()
    this.regenGeometry()
  }

  //refresh sub walltypes
  regenSubtypes() {
    //update glazed type
    this.wallTypeGlazed.height = this.glazedHeight
    this.wallTypeGlazed.width = this.glazedWidth
    this.wallTypeGlazed.exploded = this.exploded
    this.wallTypeGlazed.layers = []
    for (const layer of this.layersGlazed) {
      this.wallTypeGlazed.addLayer(buckets.wall, layer)
    }
    //update solid type
    this.wallTypeSolid.height = this.height
    this.wallTypeSolid.width = this.width
    this.wallTypeSolid.exploded = this.exploded
    this.wallTypeSolid.layers = []
    for (const layer of this.layers) {
      this.wallTypeSolid.addLayer(buckets.wall, layer)
    }
    //regenerate solid subtypes
    this.solidSubTypes = []
    // make left side
    let subtype = this.wallTypeSolid.getCopy()
    subtype.width = new Dist((this.width.ft - this.glazedWidth.ft) / 2, 0)
    this.solidSubTypes.push(subtype)
    // make right side
    subtype = this.wallTypeSolid.getCopy()
    subtype.width = new Dist((this.width.ft - this.glazedWidth.ft) / 2, 0)
    this.solidSubTypes.push(subtype)
    // make top side
    subtype = this.wallTypeSolid.getCopy()
    subtype.height = new Dist((this.height.ft - this.glazedHeight.ft) / 2, 0)
    subtype.width = new Dist(this.glazedWidth.ft, 0)
    this.solidSubTypes.push(subtype)
    // make bottom side
    subtype = this.wallTypeSolid.getCopy()
    subtype.height = new Dist((this.height.ft - this.glazedHeight.ft) / 2, 0)
    subtype.width = new Dist(this.glazedWidth.ft, 0)
    this.solidSubTypes.push(subtype)
  }

  regenGeometry() {
    Graphics.clearSceneMeshes(this.scene)
    if(this.layerCount < 1){
      return
    }
    // geometry for solid subtypes
    let left = this.solidSubTypes[0].getMesh(0, this._explodeAmount)[0]
    left.translateX( -this.glazedWidth.ft / 2 - this.solidSubTypes[0].width.ft / 2)
    this.scene.add(left)

    let right = this.solidSubTypes[1].getMesh(0, this._explodeAmount)[0]
    right.translateX( this.glazedWidth.ft / 2 + this.solidSubTypes[0].width.ft / 2)
    this.scene.add(right)

    let top = this.solidSubTypes[2].getMesh(0, this._explodeAmount)[0]
    top.translateY( this.glazedHeight.ft / 2 + this.solidSubTypes[2].height.ft / 2)
    this.scene.add(top)

    let [bottom, startingOffset] = this.solidSubTypes[3].getMesh(0, this._explodeAmount)
    bottom.translateY( -this.glazedHeight.ft / 2 - this.solidSubTypes[3].height.ft / 2)
    this.scene.add(bottom)

    // geometry for glazed subtype
    if (!this._exploded){
      startingOffset = 0
    }
    this.scene.add(this.wallTypeGlazed.getMesh(startingOffset, this._explodeAmount)[0])
    this.colorMeshes()
    updateCameraToScene(this.camera, this.scene, this.orbitControls)
  }

}